/*
 * Extra gift vase (business-os #149).
 *
 * Stemmed bouquet PDPs and the cart vase rail keep the rail and use
 * "Add an extra gift vase (optional)". The apps print step_text as text
 * and have no subtitle field, so this script bolds the phrase "extra gift
 * vase" and inserts the locked helper under the heading.
 *
 * Vase-included PDPs must not show that rail. sections/main-product.liquid
 * skips the app block when it can read the collection or step text. This
 * script hides a rail that still rendered (app settings unread, or a later
 * client rebuild).
 *
 * Detection matches snippets/fb-product-includes-vase.liquid. No new
 * metafield. See the snippet for why product type is included.
 */
(function (root) {
  var LOCKED = 'Add an extra gift vase (optional)';
  var EMPHASIZED = 'Add an <strong>extra gift vase</strong> (optional)';
  var HELPER = 'Your flowers already include a vase where shown. This is an additional vase for the recipient, not a replacement.';
  var LEGACY = [
    'Add a vase (optional)',
    'Vase (optional)',
    'Vase (option)',
    'Add a Vase',
    'Choose a vase (optional)'
  ];
  var TITLE_SELECTOR = [
    '.link-slider-title',
    '.delivery-suburb-label',
    '.delivery-suburb-label-slider',
    '.delivery-suburb-label-popup',
    '[data-fb-gift-vase-rail] label'
  ].join(', ');

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function isVaseHeadline(text) {
    var value = normalize(text);
    if (value === LOCKED) return true;
    return LEGACY.indexOf(value) !== -1;
  }

  function productIncludesVase(input) {
    input = input || {};
    if (String(input.templateSuffix || '') === 'vase-arrangement') return true;
    if (String(input.productType || '').trim() === 'Vase Arrangement') return true;
    var title = normalize(input.title);
    if (/&\s*vase\b/i.test(title)) return true;
    if (/\bvase arrangement\b/i.test(title)) return true;
    var body = String(input.descriptionText || '').replace(/\s+/g, ' ');
    if (/includes\b[^.]{0,80}\bvase\b/i.test(body)) return true;
    if (/\bvase included\b/i.test(body)) return true;
    return false;
  }

  function readConfig(doc) {
    var node = doc.getElementById && doc.getElementById('fb-gift-vase-config');
    if (!node) {
      return { page: '', templateSuffix: '', title: '', productType: '', descriptionText: '' };
    }
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      return { page: '', templateSuffix: '', title: '', productType: '', descriptionText: '' };
    }
  }

  function inScope(el, page) {
    if (!el.closest) return false;
    if (page === 'cart') {
      return !!(el.closest('.cart-left-column') || el.closest('[data-fb-gift-vase-rail]') || el.closest('.cart-app-block'));
    }
    if (page === 'product') return !!el.closest('.product__info-container');
    return false;
  }

  function suppressRail(el) {
    var block = (el.closest && (el.closest('.shopify-app-block') || el.closest('.upsell-slider-wrapper'))) || el;
    if (block.classList) block.classList.add('fb-gift-vase-suppressed');
    if (block.setAttribute) block.setAttribute('hidden', 'hidden');
    el.setAttribute('data-fb-gift-vase', 'suppressed');
  }

  function emphasizeTitle(el) {
    el.innerHTML = EMPHASIZED;
    el.setAttribute('data-fb-gift-vase', 'set');
  }

  function placeHelper(doc, titleEl) {
    var anchor = (titleEl.closest && titleEl.closest('.heading')) || titleEl;
    var next = anchor.nextElementSibling;
    if (next && next.classList && next.classList.contains('fb-gift-vase-helper')) return;
    var p = doc.createElement('p');
    p.className = 'fb-gift-vase-helper';
    p.textContent = HELPER;
    if (anchor.parentNode && anchor.parentNode.insertBefore) {
      anchor.parentNode.insertBefore(p, anchor.nextSibling);
    }
  }

  function apply(doc, config) {
    config = config || readConfig(doc);
    var page = config.page || '';
    var suppress = page === 'product' && productIncludesVase(config);
    var nodes = doc.querySelectorAll ? doc.querySelectorAll(TITLE_SELECTOR) : [];
    var suppressed = 0;
    var retitled = 0;
    Array.prototype.forEach.call(nodes, function (el) {
      if (!inScope(el, page)) return;
      if (!isVaseHeadline(el.textContent)) return;
      var state = el.getAttribute && el.getAttribute('data-fb-gift-vase');
      if (state === 'set' || state === 'suppressed') return;
      if (suppress) {
        suppressRail(el);
        suppressed += 1;
        return;
      }
      emphasizeTitle(el);
      placeHelper(doc, el);
      retitled += 1;
    });
    return { includes: suppress, suppressed: suppressed, retitled: retitled };
  }

  function boot(doc, win) {
    doc = doc || root.document;
    win = win || root;
    if (!doc || win.__fbGiftVaseBooted) return;
    win.__fbGiftVaseBooted = true;
    var config = readConfig(doc);
    function run() { apply(doc, config); }
    if (doc.readyState === 'loading' && doc.addEventListener) {
      doc.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    if (!win.MutationObserver || !doc.body) return;
    var pending = false;
    var observer = new win.MutationObserver(function () {
      if (pending) return;
      pending = true;
      var timer = win.setTimeout || setTimeout;
      timer(function () {
        pending = false;
        apply(doc, config);
      }, 50);
    });
    observer.observe(doc.body, { childList: true, subtree: true });
  }

  var api = {
    LOCKED: LOCKED,
    EMPHASIZED: EMPHASIZED,
    HELPER: HELPER,
    LEGACY: LEGACY,
    normalize: normalize,
    isVaseHeadline: isVaseHeadline,
    productIncludesVase: productIncludesVase,
    readConfig: readConfig,
    apply: apply,
    boot: boot
  };

  root.fbGiftVase = api;

  if (root.document && root.document.getElementById) boot(root.document, root);
})(typeof window !== 'undefined' ? window : globalThis);
